import React, { useState } from 'react';
import { Info, X } from 'lucide-react';

// Reusable dismissible help banner shown at the top of a page.
export default function PageHelp({ id, children }) {
  const key = `help_${id}`;
  const [show, setShow] = useState(localStorage.getItem(key) !== '1');
  if (!show) return null;
  return (
    <div className="rounded-xl border bg-accent/40 p-3 text-sm flex items-start gap-2" data-testid={`page-help-${id}`}>
      <Info className="h-4 w-4 mt-0.5 text-primary shrink-0" />
      <div className="flex-1 text-muted-foreground">{children}</div>
      <button onClick={() => { setShow(false); localStorage.setItem(key, '1'); }} className="text-muted-foreground"><X className="h-4 w-4" /></button>
    </div>
  );
}
